import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { beginPreparedRound } from '../miniTasksApi';
import { prepareMiniTaskRoundAssets, releaseMiniTaskRoundAssets } from '../roundAssets';
import WordBuildRoundView from './WordBuildRoundView';

// The parent keys this boundary by session/round. Question changes must keep the
// prepared URLs alive and must not restart preparation or the countdown.
export default function PreparedWordBuildRoundView(props) {
  const initialRoundRef = useRef(props.round);
  const [assets, setAssets] = useState(null);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  const { boardSessionId } = props;
  const isEnglish = props.round?.lesson?.code === 'ENGLISH';

  useEffect(() => {
    let active = true;
    let preparedAssets = null;
    setError('');
    (async () => {
      let urls = null;
      try {
        const round = initialRoundRef.current;
        urls = await prepareMiniTaskRoundAssets(round);
        if (!active) {
          releaseMiniTaskRoundAssets(urls);
          return;
        }
        if (!round.preview && round.status !== 'completed') {
          await beginPreparedRound(round.round_id, boardSessionId);
        }
        if (!active) {
          releaseMiniTaskRoundAssets(urls);
          return;
        }
        preparedAssets = urls;
        setAssets(urls);
      } catch (_) {
        releaseMiniTaskRoundAssets(urls);
        if (active) setError(isEnglish
          ? 'The round could not be prepared. Please try again.'
          : 'Tur hazırlanamadı. Lütfen yeniden dene.');
      }
    })();
    return () => {
      active = false;
      releaseMiniTaskRoundAssets(preparedAssets);
    };
  }, [boardSessionId, isEnglish, retry]);

  if (assets) return <WordBuildRoundView {...props} assetUrls={assets} />;

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#fffaf0', px: 2 }}>
      <Box sx={{ textAlign: 'center', color: '#5b21b6' }}>
        {!error && <CircularProgress sx={{ mb: 2 }} />}
        <Typography role={error ? 'alert' : 'status'} sx={{ fontSize: 26, fontWeight: 900 }}>
          {error || (isEnglish ? 'Preparing the round and images...' : 'Tur ve görseller hazırlanıyor...')}
        </Typography>
        {error && <Button disableRipple onClick={() => setRetry((value) => value + 1)}
          sx={{ mt: 2, minHeight: 44, minWidth: 44, fontSize: 20, fontWeight: 900, color: '#5b21b6',
            '&:hover': { bgcolor: '#ede9fe' },
            '&.Mui-focusVisible': { bgcolor: '#ede9fe', outline: '3px solid #5b21b6', outlineOffset: 3 },
          }}>{isEnglish ? 'Try again' : 'Yeniden dene'}</Button>}
      </Box>
    </Box>
  );
}
